import { Box } from '@mui/material';

import i18next from 'i18next';

import ScrollToTop from '../utils/scrollTop';

import isoImage from '../images/iso9001.jpg';

export default () => {
    const qualityData = [
        {
            title: i18next.t("iso_data_1_title"),
            description: i18next.t("iso_data_1_desc")
        },
        {
            title: i18next.t("iso_data_2_title"),
            description: i18next.t("iso_data_2_desc")
        },
        {
            title: i18next.t("iso_data_3_title"),
            description: i18next.t("iso_data_3_desc")
        },
        {
            title: i18next.t("iso_data_4_title"),
            description: i18next.t("iso_data_4_desc")
        }
    ];

    return (
        <div className="page">

            <ScrollToTop />

            {/* HERO */}
            <div className="iso _1">
                <div className='pillow'></div>

                <h1>
                    {i18next.t("iso_title")}
                </h1>

                <p
                    dangerouslySetInnerHTML={{
                        __html: i18next.t("iso_desc")
                    }}
                ></p>
            </div>

            {/* ENGAGEMENT QUALITÉ */}
            <div className="iso _2">

                <h1>{i18next.t("iso_quality_title")}</h1>

                <div className="testimonials-container">
                    <div className="content-wrapper">

                        <div className="grid-container">

                            {qualityData.map((item, index) => (
                                <div className="grid-item" key={index}>

                                    <div className="card">
                                        <h2>{item.title}</h2>

                                        {item.description &&
                                            <p>{item.description}</p>
                                        }
                                    </div>

                                </div>
                            ))}

                        </div>

                    </div>
                </div>

            </div>

            {/* CERTIFICAT */}
            <div className="iso _3">

                <h1 className="iso-certificate-title">{i18next.t("iso_certificate_title")}</h1>

                <p className="iso-certificate-desc">
                    {i18next.t("iso_certificate_desc")}
                </p>

                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', mt: 4}}>
                    <a  className="btn"
                        href="https://www.sgs.com/en/certified-clients-and-products/verify-certificate?id=6d5ba1de-42e4-4878-b63c-280ed97eee4a"
                        target="_blank"
                        rel="noopener noreferrer">
                        Vérifier le certificat
                    </a>

                    <img className="iso-certificate" src={isoImage} alt="ISO 9001 Certificate"/>
                </Box>
            </div>
        </div>
    );
};